var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-row', {
    staticClass: "ma-16"
  }, [_vm._l(_vm.watchers, function (item) {
    return [_c('v-col', {
      key: item._user,
      staticClass: "pa-4",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-chip', {
      staticClass: "font-size-12 pl-2",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "width": "24px !important",
        "height": "24px !important",
        "color": "grey-f7"
      }
    }, [_c('v-img', {
      scopedSlots: _vm._u([{
        key: "placeholder",
        fn: function fn() {
          return [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-account")])];
        },
        proxy: true
      }], null, true)
    })], 1), _c('span', [_vm._v(" " + _vm._s(item.name) + " (" + _vm._s(item.username) + ") ")])], 1)], 1)];
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }